import React, { useState } from 'react';
import './ThemeChoiceModal.css';

export default function ThemeChoiceModal({ open, onChoose, onClose, onPreview }) {
  const [selected, setSelected] = useState('light');
  if (!open) return null;

  const handleApply = () => {
    onChoose(selected);
  };

  const onKeyPick = (e, value) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setSelected(value);
      if (typeof onPreview === 'function') onPreview(value);
    }
  };
  return (
    <div className="theme-choice-backdrop" role="dialog" aria-modal="true" aria-label="Choisir un thème">
      <div className="theme-choice-modal">
        <div className="theme-choice-header">
          <h2 className="theme-choice-title">Bienvenue sur Version Net</h2>
          <p className="theme-choice-desc">
            Choisissez votre apparence préférée. Le thème clair offre une lecture lumineuse et aérée,
            le thème sombre est plus reposant dans des environnements peu éclairés. Vous pourrez changer
            de thème à tout moment depuis la barre de navigation.
          </p>
        </div>
        <div className="theme-choice-split">
          <div
            className={`theme-preview light ${selected === 'light' ? 'selected' : ''}`}
            role="button"
            tabIndex={0}
            aria-pressed={selected === 'light'}
            onClick={() => onChoose('light')}
            onKeyDown={(e) => onKeyPick(e, 'light')}
          >
            <div className="preview-header">Clair</div>
            <div className="preview-body">
              <div className="preview-card" />
              <div className="preview-card" />
            </div>
            <button
              type="button"
              className="btn-choose"
              onClick={(e) => { e.stopPropagation(); onChoose('light'); }}
              aria-label="Choisir le thème clair"
            >
              Choisir
            </button>
          </div>
          <div
            className={`theme-preview dark ${selected === 'dark' ? 'selected' : ''}`}
            role="button"
            tabIndex={0}
            aria-pressed={selected === 'dark'}
            onClick={() => onChoose('dark')}
            onKeyDown={(e) => onKeyPick(e, 'dark')}
          >
            <div className="preview-header">Sombre</div>
            <div className="preview-body">
              <div className="preview-card" />
              <div className="preview-card" />
            </div>
            <button
              type="button"
              className="btn-choose"
              onClick={(e) => { e.stopPropagation(); onChoose('dark'); }}
              aria-label="Choisir le thème sombre"
            >
              Choisir
            </button>
          </div>
        </div>
        <div className="theme-choice-footer">
          <p className="theme-choice-note">
            Astuce: cliquez sur un aperçu pour le sélectionner puis validez ci-dessous. Vous pourrez changer d’avis à tout moment depuis la barre de navigation.
          </p>
          <div className="theme-choice-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Plus tard</button>
            <button type="button" className="btn-primary" onClick={handleApply} aria-label={`Appliquer le thème ${selected}`}>Continuer</button>
          </div>
        </div>
        <button type="button" className="theme-choice-close" onClick={onClose} aria-label="Fermer">×</button>
      </div>
    </div>
  );
}
